import { Graphics, ResourceBatch, RenderLoop, Configuration, EventManager, Debug, Initializer, ResourceContainer } from './engine';
import Loader from './Loader';

// APP
import MainApplication from './MainApplication';

class AppApi
{
  init()
  {
    this.application = new MainApplication();
    this.loader = new Loader(this);

    this.render_loop = new RenderLoop(this.loader, Graphics);
    this.config = Configuration;

    let app_container = document.querySelector('.webgl-canvas');
    let canvas = document.querySelector('.webgl-canvas');

    Initializer.init(canvas, app_container, {
      antialias: true,
      logarithmicDepthBuffer: true,
    });
    Configuration.dpr = 1;//window.devicePixelRatio;
    this.application.init(Graphics);
    this.updateLabelsCallback = undefined;
  }

  load(settings = {})
  {
    this.init();

    window.app = this.application;
    window.ViewApi = this;
    window.settings = settings;

    this.loader.load();

    for (const [key, value] of Object.entries(settings)) 
    {
      Configuration[key] = value;
    }

  }

  dispose()
  {
    this.application.dispose();
    Initializer.dispose(this.render_loop);
  }

  draw_debug_axis()
  {
    Debug.draw_axis();
  }

  register_event(name, callback)
  {
    EventManager.on(name, callback);
  }

  set_resource(name, resource)
  {
    ResourceContainer.set_resource(name, resource);
  }

  set_settings(settings)
  {
    window.settings = settings;
  }

  start_main_app()
  {
    this.render_loop.set_state(this.application);
  }

  start()
  {
    this.render_loop.start();
  }

  stop()
  {
    this.render_loop.stop();
  }

  take_screenshot(callback)
  {
    Graphics.take_screenshot(callback);
  }

  download_blob(blob)
  {
    Graphics.download_screenshot(blob);
  }

  setSun(aBoolean)
  {
    this.application.setSun(aBoolean);
  } 

  updateLabels(frg_w, og_w, mg_w, so_w, sm_w, u_value, g_o, g_m, rotate_frg) 
  {
    // the function that sets the timeout and the important function call in the end
    const timeout = () => 
    {
      return setTimeout( (() => 
      {
        // what wants to be called
        this.application.updateLabels(frg_w, og_w, mg_w, so_w, sm_w, u_value, g_o, g_m, rotate_frg);
      }).bind(this), 100 );
    };

    // we damp the call
    if( this.updateLabelsCallback === undefined) 
    {
      this.updateLabelsCallback = timeout();
    }
    else 
    {
      clearTimeout(this.updateLabelsCallback);
      this.updateLabelsCallback = timeout();
    }
  }
}

const Api = new AppApi();
export { Api, ResourceBatch };
